import React, { useLayoutEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";

import Homepage from "./Homepage";
import InteriorDesignPage from "./InteriorDesignPage";

function ScrollToSection() {
  const { pathname, hash, key } = useLocation();
  useLayoutEffect(() => {
    function restorePosition() {
      if (hash) {
        document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "instant", block: "start" });
      } else {
        document.getElementById("main-content")?.focus({ preventScroll: true });
        window.scrollTo({ top: 0, behavior: "instant" });
      }
    }
    restorePosition();
    // Repeat after navigation focus settles, including a current-page footer link.
    const frame = requestAnimationFrame(restorePosition);
    return () => cancelAnimationFrame(frame);
  }, [pathname, hash, key]);
  return null;
}

function LegacyStudioRedirect() {
  const { hash, search } = useLocation();
  return <Navigate to={{ pathname: "/studio", hash, search }} replace />;
}

function App() {
  return (
    <Router>
      <ScrollToSection />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/studio" element={<InteriorDesignPage />} />
        <Route path="/interior-design" element={<LegacyStudioRedirect />} />
      </Routes>
    </Router>
  );
}

export default App;

